import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivityListBase, SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ActivityFoldOneColumn } from '../../activity/components/activityFoldOneColumn';
import { ActivitiesProps } from '../../activity/components/activityList';
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { ViewAllSectionHeader } from './viewAllSectionHeader';

export const AssetActivityFold = (props: ActivitiesProps) => {
  const windowDimensions = useWindowDimensions();
  const maxHeight = windowDimensions.height && windowDimensions.height - 280;
  const { issueId } = useParams();

  if (issueId) {
    return (
      <ActivityFoldOneColumn
        assetId={props.assetId}
        onIssueSelected={props.onIssueSelected}
        selectedIssue={issueId}
        showAssetName={false}
        maxHeight={maxHeight}
      />
    );
  }

  return <AssetActivityFoldCompact {...props} />;
};

const AssetActivityFoldCompact = ({
  assetId,
  onIssueSelected,
}: ActivitiesProps) => {
  const { t } = useTranslation();
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();
  const [dataLoaded, setDataLoaded] = useState('');
  const handleDataLoaded = useCallback((data: any[]) => {
    if (data?.length > 0) {
      setDataLoaded(data[0].id);
    } else {
      setDataLoaded('');
    }
  }, []);
  const isDetailPage = location.pathname.includes('/detail');

  const handleViewAllIssues = useCallback(
    async () => {
      if (!isDetailPage) {
        await onSlideChange(SlideAction.NEXT);

        navigate(`/assets/${assetId}/detail`);
      }
    },
    [navigate, assetId, onSlideChange, isDetailPage]
  );

  const handleIssueSelected = useCallback(
    (id: string) => {
      onIssueSelected?.(id);
    },
    [onIssueSelected]
  );

  return (
    <View style={styles.containerHeightCropCircle}>
      <ViewAllSectionHeader
        title={t('asset.header.recentActivity')}
        onPress={handleViewAllIssues}
        disabled={!dataLoaded}
      />
      <View style={styles.activityListCropCircle}>
        <ActivityListBase
          onIssueSelected={handleIssueSelected}
          onDataLoaded={handleDataLoaded}
          assetId={assetId}
          excludeFilter={true}
          showTextEmpty={true}
          cardVariant="assetCompact"
          pageSize={3}
          showTopBar={false}
          filterKey={
            assetId
              ? ActivityFilterKey.AssetActivity
              : ActivityFilterKey.Activity
          }
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerHeightCropCircle: {
    maxHeight: 262,
    minHeight: 80,
    height: '100%',
    width: '100%',
    paddingHorizontal: 16,
    paddingTop: 10,
  },
  activityListCropCircle: {
    height: '100%',
    minHeight: 100,
    overflow: 'hidden',
    marginBottom: 0,
  },
});
